import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { EMPLOYEE_BLUE, WHITE, PINK_RED } from "../colors";
import HeightBox from "../components/HeightBox";
import CircularProgress from "@mui/material/CircularProgress";
import { useHistory } from "react-router-dom";
import { IconButton, Radio, RadioGroup } from "@mui/material";
import FinService from "../services/finService";
import { FIN_TYPES } from "../constants/finTypes";
import { getAllCustomers } from "../actions/customers";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";

const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 435,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: WHITE,
  paddingLeft: 10,
  minWidth: 435,
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  padding: 20,
  paddingLeft: 20,
  paddingRight: 20,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  bgcolor: "#E1DEDE",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
};

const CustomButton = styled(Button)(({ theme }) => ({
  height: 40,
  minWidth: 200,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
  color: WHITE,
  backgroundColor: EMPLOYEE_BLUE,
}));

const types = [
  {
    label: "Income",
    value: "Income",
  },
  {
    label: "Expense",
    value: "Expense",
  },
  {
    label: "All",
    value: "All",
  },
];

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 18,
}));
const initialValues = {
  isExpense: true,
  customer: null,
  type: null,
  description: null,
  dateTimeCreated: new Date(),
  amount: 0.0,
};
export const AddFinancialRecordContainerModel = (props) => {
  const dispatch = useDispatch();

  const customerList = useSelector((state) => state.customerList);
  const { customers: customersStore } = customerList;
  let history = useHistory();
  const { cancelFunction, openModel, handleCancelModel } = props;
  const [formValues, setFormValues] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [screenInfo, setScreenInfo] = useState({
    screenName: "",
    customers: [],
  });
  useEffect(() => {
    const getPageInfo = async () => {
      if (customersStore === null) {
        dispatch(getAllCustomers());
      }
      setScreenInfo({
        ...screenInfo,
        customers: customersStore?.map((customer) => ({
          label: customer.full_name,
          id: customer.id,
        })),
      });
    };

    getPageInfo();
  }, []);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await FinService.createFin(formValues);

      alert("Successfully added the financial");
      setFormValues(initialValues);
      cancelFunction();
      props.setIsNewFinAdded(true);
      setLoading(false);
      history.push("/finance");
      return true;
    } catch (e) {
      setLoading(false);
      alert(e);
    }
  };
  return (
    <Modal
      open={openModel}
      onClose={handleCancelModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="delete"
          onClick={cancelFunction}
          sx={{ position: "absolute", right: "20px", top: "20px" }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Add Financial Record
        </Typography>
        <HeightBox height={10} />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={screenInfo.customers}
          onChange={(e, val) => setFormValues({ ...formValues, customer: val.id })}
          sx={{ width: 435 }}
          renderInput={(params) => <CustomTextField {...params} label="Select Customer " />}
        />
        <HeightBox height={10} />
        <FormControl component="fieldset">
          <FormGroup aria-label="position" row>
            <RadioGroup
              value={formValues.isExpense}
              onChange={(e) => setFormValues({ ...formValues, isExpense: e.target.value })}
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel value={true} control={<Radio />} label="Expense" />
              <FormControlLabel value={false} control={<Radio />} label="Income" />
            </RadioGroup>
          </FormGroup>
        </FormControl>
        <HeightBox height={10} />
        <CustomSelect
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          placeholder="Select Type (Type 1,Type 2,Type 3)"
          onChange={(e) => setFormValues({ ...formValues, type: e.target.value })}
        >
          {FIN_TYPES?.map((type, index) => (
            <MenuItem key={index} value={type}>
              {type}
            </MenuItem>
          ))}
        </CustomSelect>
        <HeightBox height={10} />
        <Stack direction="row" justifyContent="flex-start">
          <CustomTypography>Amount</CustomTypography>
        </Stack>
        <HeightBox height={10} />

        <CustomTextField
          type="number"
          step="0.01"
          min="0"
          value={formValues.amount}
          onChange={(e) => setFormValues({ ...formValues, amount: e.target.value })}
          InputProps={{ disableUnderline: true }}
        />
        <HeightBox height={10} />
        <Stack direction="row" justifyContent="flex-start">
          <Typography textAlign="left">Description</Typography>
        </Stack>
        <HeightBox height={10} />
        <CustomTextField
          multiline
          rows={2}
          value={formValues.description}
          onChange={(e) => setFormValues({ ...formValues, description: e.target.value })}
        />
        <HeightBox height={10} />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateTimePicker
            renderInput={(props) => <CustomTextField placeholder="Date and Time" {...props} />}
            value={formValues.dateTimeCreated}
            onChange={(newValue) => {
              setFormValues({ ...formValues, dateTimeCreated: newValue });
            }}
          />
        </LocalizationProvider>
        <HeightBox height={10} />
        <Stack direction="row" alignItems="center" spacing={3}>
          <CustomButton
            style={{ backgroundColor: PINK_RED }}
            onClick={() => {
              cancelFunction();
            }}
          >
            Cancel
          </CustomButton>
          <CustomButton
            onClick={() => handleSubmit()}
            disabled={
              formValues.customer === null ||
              formValues.type === null ||
              formValues.description === null ||
              formValues.amount === 0.0 ||
              loading
            }
          >
            {loading ? <CircularProgress size={15} /> : "Add Record"}
          </CustomButton>
        </Stack>
      </Box>
    </Modal>
  );
};
